export enum StationListTypes {
  SettingType = 1,
  DispenseType = 2,
}
